import { Box } from "@mui/material";
import MultiDateRangePicker from "./MultiDateRangePicker";

const QuickDateMultiRange = ({ setRanges, reset }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <MultiDateRangePicker setRanges={setRanges} reset={reset} />
    </Box>
  );
};

export default QuickDateMultiRange;
